import { useState, useEffect } from 'react';
import { awardsData } from '../data/awards';
import useScrollReveal from '../hooks/useScrollReveal';
import './Awards.css';

export default function Awards() {
  useScrollReveal();
  const [grants, setGrants] = useState(awardsData);

  useEffect(() => {
    fetch('/api/grants')
      .then(r => {
        if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
        return r.json();
      })
      .then(data => {
        if (data && data.items) {
          setGrants(data.items);
        } else if (Array.isArray(data)) {
          setGrants(data);
        }
      })
      .catch(err => {
        console.error("Fetch grants error:", err);
      });
  }, []);

  return (
    <main>
      <section className="page-hero" aria-labelledby="awards-heading">
        <div className="container reveal reveal-up">
          <span className="section-label">Recognition</span>
          <h1 id="awards-heading">International Awards, Fellowships & Grants</h1>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.75)' }}>
            A history of globally recognized academic excellence and funded research.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-narrow">
          <div className="awards-timeline">
            {grants.map((grant, i) => (
              <div key={grant.id} className={`award-card reveal reveal-up delay-${(i % 3) + 1}`}>
                <span className="award-card__year">{grant.year}</span>
                <h3 className="award-card__title">{grant.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
